var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.withLabel)?_c('a',{attrs:{"href":_vm.backLink,"title":_vm.label}},[_c('div',{staticClass:"page-nav__icon page-nav__icon--arrow-left"}),_vm._v(" "+_vm._s(_vm.label)+"\n")]):_c('a',{attrs:{"href":_vm.backLink,"title":_vm.label}},[_c('div',{staticClass:"page-nav__icon page-nav__icon--grid"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c21687","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/mtg/assets/js/theme-components/BackLink.vue
// module id = 3u9G
// module chunks = 0